import React, { useContext, useEffect } from "react";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import ChartView from "../chart/ChartViewv2";
import PackageOverview from "../packageOverview/PackageOverviewv2";
import { getRefreshInterval } from "./utils/utils";
import { getNewRefreshInterval } from "./utils/utils";
import { getDocumentURL } from "../handler/ParentDataHandler";
import { getBaseUrl } from "../outboundAmzl/util/Util";
import Divider from "@amzn/meridian/divider";

const PVAView = (data) => {
  const { cycles } = useContext(CycleFilterContext);
  const { dispatch } = useContext(PVAOverviewContext);

  const getPVAData = () => {
    getDocumentURL().then((result) => {
      const baseUrl = getBaseUrl(result);
      dispatch({
        type: "LOAD_PVA_DATA",
        data: {
          filter: cycles,
          dispatcher: dispatch,
          processName: data.pva.processName,
          baseUrl: baseUrl,
        },
      });
    });
  };
  const getPlannedHoursData = () => {
    getDocumentURL().then((result) => {
      const baseUrl = getBaseUrl(result);
      dispatch({
        type: "LOAD_PLANNED_HOURS_DATA",
        data: {
          filter: cycles,
          dispatcher: dispatch,
          processName: data.pva.processName,
          baseUrl: baseUrl,
        },
      });
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getPVAData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getPVAData();
        }
      }, getRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [cycles]);

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getPlannedHoursData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getPlannedHoursData();
        }
      }, getNewRefreshInterval());
      return () => clearInterval(interval);
    }
  }, [cycles]);

  return (
    <div>
      <ChartView
        breaksDataSources={data.breaksDataSources}
        view={{ processName: data.pva.processName }}
      />
      <Divider size="medium" spacingBefore="400" spacingAfter="400" />
      <PackageOverview view={{ processName: data.pva.processName }} />
    </div>
  );
};

export default PVAView;



// WEBPACK FOOTER //
// ./src/components/overview/PVAViewv2.js